
import {
  afterNextRender,
  booleanAttribute,
  Directive,
  ElementRef,
  inject,
  input,
  output,
  DOCUMENT
} from '@angular/core';
import { NgClickOutsideExcludeToken } from './click-outside-exclude.directive';

export function arrayAttribute(events: string | string[]) {
  if (Array.isArray(events)) {
    return events;
  } else {
    return events.split(',');
  }
}

@Directive({
  selector:
    '[clickOutside]:not([delayClickOutsideInit]):not([attachOutsideOnClick])',
  standalone: true,
})
export class ClickOutsideDirective {
  /**
   * Enables directive.
   */
  clickOutsideEnabled = input(true, { transform: booleanAttribute });

  /**
   * A comma-separated list of events to cause the trigger.
   * ### For example, for additional mobile support:
   * `[clickOutsideEvents]="'click,touchstart'"`
   */
  clickOutsideEvents = input(['click'], {
    transform: arrayAttribute,
  });

  /**
   * Outside Click Event
   */
  clickOutside = output<Event>();

  excludeDirective = inject(NgClickOutsideExcludeToken, {
    host: true,
    optional: true,
  });
  protected _el = inject(ElementRef);
  private document = inject<Document>(DOCUMENT);

  constructor() {
    this._initOnClickBody = this._initOnClickBody.bind(this);
    this._onClickBody = this._onClickBody.bind(this);
    afterNextRender(() => this._init());
  }

  ngOnDestroy() {
    this._removeClickOutsideListener();
  }

  protected _init() {
    this._initOnClickBody();
  }

  protected _initOnClickBody() {
    this._initClickOutsideListener();
  }

  protected _emit(ev: Event) {
    this.clickOutside.emit(ev);
  }

  protected _initClickOutsideListener() {
    this.clickOutsideEvents().forEach((e) =>
      this.document.addEventListener(e, this._onClickBody)
    );
  }

  protected _removeClickOutsideListener() {
    this.clickOutsideEvents().forEach((e) =>
      this.document.removeEventListener(e, this._onClickBody)
    );
  }

  private _onClickBody(ev: Event) {
    if (!this.clickOutsideEnabled()) {
      return;
    }

    if (
      !this._el.nativeElement.contains(ev.target) &&
      !this.excludeDirective?.isExclude(ev.target)
    ) {
      this._emit(ev);
    }
  }
}
